import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const PageStyles = styled(IonPage)`
  --background: #14111e;
  background: #14111e;

  ion-content {
    --background: #14111e;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 16px 32px;
  min-height: 100%;
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
`;

export const CheckIcon = styled.div`
  width: 233px;
  height: 127px;
  margin-bottom: 24px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const StepsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 400px;
`;

export const Step = styled.div<{ $completed?: boolean; $active?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border-radius: 16px;
  background: ${({ $active }) =>
    $active ? 'rgba(128, 62, 255, 0.07)' : 'rgba(255, 255, 255, 0.05)'};
  position: relative;

  ${({ $active }) =>
    $active &&
    `
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 16px;
      padding: 1px;
      background: linear-gradient(135.59deg, #7F36F3 -3.67%, #ED0D80 106.36%);
      -webkit-mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }
  `}

  &[data-has-extra-content='true'] {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    .email-hint {
      opacity: 0.6;
    }
  }
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StepNumber = styled.div<{
  $completed?: boolean;
  $active?: boolean;
}>`
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ $active }) => {
    if ($active)
      return 'linear-gradient(135.59deg, #7F36F3 -3.67%, #ED0D80 106.36%)';
    return 'rgba(255, 255, 255, 0.1)';
  }};
  box-shadow: ${({ $active }) =>
    $active
      ? 'inset 0px 1.45px 1.45px 0px rgba(255, 255, 255, 0.25), 0px 1.45px 1.45px 0px rgba(0, 0, 0, 0.25)'
      : 'none'};

  img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }
`;

export const StepContent = styled.div<{ $completed?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: ${({ $completed }) => ($completed ? '10px' : '0')};
  opacity: ${({ $completed }) => ($completed ? 0.5 : 1)};
  text-decoration: ${({ $completed }) =>
    $completed ? 'line-through' : 'none'};
  text-decoration-color: ${({ $completed }) =>
    $completed ? 'rgba(255, 255, 255, 0.6)' : 'transparent'};

  .email-hint {
    opacity: 0.6;
  }
`;

export const StoreLinks = styled.div`
  display: flex;
  gap: 12px;

  a {
    display: block;

    img {
      height: 40px;
      width: auto;
    }
  }
`;

export const ContactSection = styled.div`
  margin-top: auto;
  padding-top: 32px;

  a {
    color: white;
    text-decoration: none;
  }
`;
